import { Collapsible } from '../interfaces';
import { FunctionalCharacteristicType } from './functional-characteristic-type';
import { FunctionalAnalysesArea } from './functional-analyses-area';
import { FunctionalAnalysesImportanceEnum } from './enums/functional-analyses-importance-enum';

export class FunctionalAnalysesData implements Collapsible {
  uncontrolledTransactionFunctionalAnalysisDataId?: number;
  tbaFunctionalAnalysisDataId?: number;
  pbaFunctionalAnalysisDataId?: number;
  functionalAnalysisArea: FunctionalAnalysesArea;
  functionalCharacteristicType: FunctionalCharacteristicType;
  characteristicName: string;
  srcContribution?: number;
  destContribution?: number;
  testedPartyContribution?: boolean;
  otherParticipantContribution?: boolean;
  discussion: string;
  sortOrder: number;
  importance?: FunctionalAnalysesImportanceEnum;
  collapsed: boolean;
}
